import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { hidePopup } from 'swag-client-common/redux/popup-manager/popup-manager.actions';
import { showNotification } from 'swag-client-common/redux/notification/notification.actions';
import { resetPopupWizard } from '../../../../../redux/collect-sizes/collect-sizes.actions';
import { generatedLinkSelector } from '../../../../../redux/collect-sizes/collect-sizes.selectors';
import { isLimitedEditionSelector } from '../../../../../redux/product/product.selectors';
import { GeneratedLinkDialog as GeneratedLinkDialogComponent } from './generated-link-dialog';
const mapStateToProps = createStructuredSelector({
  link: generatedLinkSelector,
  isLimitedEdition: isLimitedEditionSelector
});
const mapDispatchToProps = dispatch => ({
  onCopy: () => {
    dispatch(showNotification({
      text: 'Successfully copied!'
    }));
  },
  onClose: () => {
    dispatch(hidePopup());
    dispatch(resetPopupWizard());
  }
});
export const GeneratedLinkDialog = connect(mapStateToProps, mapDispatchToProps)(GeneratedLinkDialogComponent);